export default __webpack_public_path__ + "resources/icons/n311-c7ef.png";